/**
 * @title costcopay-fobs.js: Sub module for Account pages
 * @description: This module is used to hanle management of costco pay fobs
 */
define([], function() {
	let CostcoPayFob = {
			
		SORT_BY_FOB_NAME_ASC: '1',
		SORT_BY_FOB_NAME_DESC: '2',
		
		url : {
			MANAGE_FOB_ADD_UPDATE: '/AjaxManageCostcoPayFobCmd',
			GET_COSTCO_PAY_FOB: '/AjaxCostcoPayGetFobsCmd'
		},
		
		/**
		 * Contain the list of fobs that is associated with the user
		 * Slight weirdness UX display suspended fobs as deactivated
		 * and we do not display deactivated fobs at all
		 */
		fobs: {
			active:[],
			deactivated:[]
		},
		/**
		 * Function used to get the current active costco pay fob
		 * form.
		 * If the user has no active or suspended fob the active form
		 * will be inline on the screen, however we also have the form
		 * displayed within the modal
		 */
		getForm :function() {
			if($('#add_fob_form').is(':visible') || $('#add_fob_form').css('display') != 'none' )
				return $('#add_fob_form');
			else
				return $('#costco-pay-dialog-modal');
		},
		/**
		 *  Function used to get the next available default fobName to be displayed to the user
		 *  We will try to ensure the default fob name as unique by calculating the maximum
		 *  enumeration number in the active and deactivated fob collection and adding 1 to it
		 *  
		 */
		getDefaultFobName: function() {
			let baseFobName = messages.COSTCO_PAY_FOB_DEFAULT_NAME;
			
			let defaultFobReducer = (accumulator, currentValue) => {
				if(currentValue.fobName.startsWith(baseFobName)) {
					let currFobEnum = currentValue.fobName.substr(baseFobName.length).trim();
					return Math.max(accumulator, currFobEnum);
				}
				return accumulator;
			}
			//Calculating the max enumeration for fob between the active and deactivated ones and setting 0 as the default accumulator
			let maxDefaultFobName = Math.max(CostcoPayFob.fobs.active.reduce(defaultFobReducer, 0), CostcoPayFob.fobs.deactivated.reduce(defaultFobReducer, 0));
			
			return baseFobName +" "+ (maxDefaultFobName+1);
		},
		/**
		 * Initializer for costcoPay this function will be triggered
		 * when the page finished rendering.
		 * 
		 * If there is an associated costcoPayUserId the method will try
		 * to get the associated fobs
		 * 
		 * If we are running on the mobile app we will show the scan button on the
		 * add fob forms
		 */
		init: function() {
			if(document.readyState == 'complete') {
				this.getCostcoPayFobs(true);
				if(COSTCO.util.isRunningOnMobileApp())
	    			  $('.fob-scan-btn').show();
	    		  else
	    			  $('.fob-scan-btn').hide();
			}
			else{
				$(window).on('load',function(){
	    		  COSTCO.CostcoPayFob.getCostcoPayFobs(true);
	    		  if(COSTCO.util.isRunningOnMobileApp())
	    			  $('.fob-scan-btn').show();
	    		  else
	    			  $('.fob-scan-btn').hide();
	    	  })
			}
			
		},
		/**
		 * Helper to get the list of associated costcoPayFob
		 * associated with the costcoPayId
		 * 
		 * Upon completion we will split the fob list from the 
		 * AjaxCostcoPayGetFobsCmd into the respective fob object list entry
		 * per status. It will then render the costco fob section.
		 * 
		 * @param costcoPayId costcoPayId associated with the user
		 */
		getCostcoPayFobs: function(init) {
			if(typeof COSTCO.CostcoPayAccountInformation.getCostcoPayUserId() !== 'undefined'
				 && COSTCO.CostcoPayAccountInformation.getCostcoPayUserId() !== '') {
				if(!COSTCO.CostcoPayAccountInformation.hasCostcoPayMembership()) {
					$('#add_fob_form input').prop('disabled', true);
				}
				else {
					$('#add_fob_form input').prop('disabled', false);
				}
				COSTCO.util.ajax({
			        url:  CostcoPayFob.url.GET_COSTCO_PAY_FOB,
			        method: 'GET',
			        dataType: 'json',
			        data: {
			          costcoPayId: encodeURIComponent(COSTCO.CostcoPayAccountInformation.getCostcoPayUserId())
			        },
			        done: function(data, textStatus, jqXHR, options) {
			          CostcoPayFob.fobs.active = [];
			          CostcoPayFob.fobs.active = CostcoPayFob.fobs.active.concat(JSON.parse(data.activeFobs));
			          CostcoPayFob.fobs.deactivated = [];
			          CostcoPayFob.fobs.deactivated = CostcoPayFob.fobs.deactivated.concat(JSON.parse(data.deactivatedFobs));
			          CostcoPayFob.populateFobSection();
			          //Only try to handle the mobile deep linking on initialization
			          //of the page
			          if(init) {
			        	  CostcoPayFob.handleMobileDeepLink();
			          }
			        },
			    });
			}
			else {
				//User has not been registered for costcoPay so hide the manage fob
				//And disable the add single fob form
				$('#manage-fobs').hide();
				$('#add_fob_form input').prop('disabled', true);
				 if(init) {
		        	  CostcoPayFob.handleMobileDeepLink();
		          }
				
			}
			let numFobs = CostcoPayFob.fobs.active.length + CostcoPayFob.fobs.active.length;
		},
		/**
		 * Handle an initial request with a fobId in the request parameter
		 * this will indicate the user got here by scanning the mobile qr code
		 */
		handleMobileDeepLink: function() {
			
			let fobId = COSTCO.util.getParameterByName('fobId');
			let numFobs = CostcoPayFob.fobs.active.length + CostcoPayFob.fobs.active.length;
			
			if(typeof fobId !== 'undefined' && fobId != null && fobId !== '') {
				if(numFobs == 0) {
					$('#add_fob_form').find('#fob_number_input').val(fobId);
					$('#add_fob_form').find('#fob_number_verify_input').val(fobId);
				}
				else {
					CostcoPayFob.openAddEditFobModal(fobId, 'add');
				}
			}
		},
		/**
		 * Function to render the stored fob data to the screen. Which will flow as follows
		 *   1. Hide fob sections
		 *   2. Call a helper function to reneder the fobs onscreen
		 *   3. Depending on the filter option show only the relevant fob section
		 */
		populateFobSection: function() {
			//Hide fob while we work on it
			let numDisplayedFobs = CostcoPayFob.fobs.active.length + CostcoPayFob.fobs.deactivated.length;
			
			if(!(COSTCO.CostcoPayAccountInformation.hasCostcoPayMembership() && COSTCO.CostcoPayAccountInformation.hasPaymentMethod())) {
				$('#add_addtl_fob_btn').prop('disabled', true);
				$('#add_fob_form input').prop('disabled', true);
			}
			else {
				$('#add_addtl_fob_btn').prop('disabled', false);
				$('#add_fob_form input').prop('disabled', false);
			}
			
			if(numDisplayedFobs == 0) {
				$('#manage-fobs').hide();
				$('#add_fob_form').show();
			}
			else {
				$('#manage-fobs').show();
				$('#add_fob_form').hide();
				CostcoPayFob.renderCostcoPayFobList('#active-fob-list', CostcoPayFob.sort(CostcoPayFob.fobs.active),messages.COSTCO_PAY_FOB_NO_ACTIVE_FOUND);
				CostcoPayFob.renderCostcoPayFobList('#deactivated-fob-list', CostcoPayFob.sort(CostcoPayFob.fobs.deactivated),messages.COSTCO_PAY_FOB_NO_DEACTIVATED_FOUND);
				//Only show the selected fob type
				let showFobType = $('option:selected', $('#fob-status-filter')).val();
				if(showFobType === 'deactivated') {
					$('#active-fobs').hide();
					$('#deactivated-fobs').show();
				}
				else if(showFobType === 'active') {
					$('#active-fobs').show();
					$('#deactivated-fobs').hide();
				}
				else{
					$('#active-fobs').show();
					$('#deactivated-fobs').show();
				}
			}
			
		},
		/**
		 * Function used to sort the fobList based on the sort selected by
		 * the user
		 */
		sort: function(fobList) {
			let sortedFobList = [];
			let sortType = $('option:selected', $('#fob-sort-by')).val();
			if (sortType === CostcoPayFob.SORT_BY_FOB_NAME_ASC) {
				sortedFobList = fobList.sort(function(elem1, elem2) {
		          let name1 = elem1.fobName.toLowerCase();
		          let name2 = elem2.fobName.toLowerCase();
		          return ((name1 < name2) ? -1 : ((name1 > name2) ? 1 : 0));
		        });
		      }
		      if (sortType === CostcoPayFob.SORT_BY_FOB_NAME_DESC) {
		    	  sortedFobList = fobList.sort(function(elem1, elem2) {
		          let name1 = elem1.fobName.toLowerCase();
		          let name2 = elem2.fobName.toLowerCase();
		          return ((name1 > name2) ? -1 : ((name1 < name2) ? 1 : 0));
		        });
		      }
		      return sortedFobList;
		},
		/**
		 * Function used to iterate though the fobList to render each fob
		 * and append it to the given containerId
		 */
		renderCostcoPayFobList: function(containerId, fobList, defaultMessage) {
			$(containerId).html('');
			if(fobList.length > 0) {
				$.each(fobList, function(index, value) {
					
					//set the value to a new object as a copy
					//so we can change the value for display but maintain
					//original value for the form
					let fobDisplay = Object.assign({},value);
					let template = COSTCO.util.tmpl('tmpl_costco_pay_fob_box',fobDisplay);
					template = $(template);
					if(value.fobStatus.toLowerCase() === 'suspended') {
						template.addClass('deactivated');
						template.find('.deactivate-link').addClass('hide');
					}
					else {
						template.find('.reactivate-link').addClass('hide');
					}
					if(!(COSTCO.CostcoPayAccountInformation.hasCostcoPayMembership() && COSTCO.CostcoPayAccountInformation.hasPaymentMethod())) {
						template.find('.edit-link').addClass('hide');
						template.find('.reactivate-link').addClass('hide');
					}
					
					$(containerId).append(template);
				});
			}
			else {
				$(containerId).append(defaultMessage);
			}
		},
		/**
		 * Helper function used to get the raw fobData from the 
		 * fobs object given a fobNumber
		 * 
		 * if it cannot find a fob that match its fobNumber undefined is returned
		 */
		getFobData: function(fobNumber) {
			let fobData = undefined;
			if(typeof fobNumber !== 'undefined') {
				fobData = CostcoPayFob.fobs.active.find(function (element){
					return element.fobNumber == fobNumber;
				});
				if(typeof fobData === 'undefined') {
					fobData = CostcoPayFob.fobs.deactivated.find(function (element){
						return element.fobNumber == fobNumber;
					});
				}
			}
			return fobData;
		},
		/**
		 * Function used to open the fob edit modal under edit mode
		 */
		editFob: function(element) {
			let fobNumber = $(element).data("fob-num");
			CostcoPayFob.openAddEditFobModal(fobNumber, 'edit');
		},
		/**
		 * Function used to open the fob add modal
		 * We feed -1 to the fobNumber field to ensure
		 * no data is found which will display a blank form
		 */
		addFob: function(element) { 
			if(CostcoPayFob.validateCostcoPayFobForm(element)) {
				if($(element).find('[name=costcoPayUserId]').val() === "")
					$(element).find('[name=costcoPayUserId]').val(COSTCO.CostcoPayAccountInformation.getCostcoPayUserId());
				let newFobData  =  COSTCO.util.objectifyArray($(element).serializeArray());
				CostcoPayFob.manageCostcoPayFob(newFobData, 'add');
			}
		},
		/**
		 * Helper function used to suspend a fob
		 */
		deactivateFob: function(element) {
			let fobNumber = $(element).data("fob-num");
			let fobData = CostcoPayFob.getFobData(fobNumber);
			COSTCO.dialog.showAndHideModal({
		        title: messages.COSTCO_PAY_FOB_DISABLE_MODAL_TITLE,
		        body: COSTCO.util.tmpl('tmpl_disable_fob_modal',fobData),
		        primary: messages.COSTCO_PAY_FOB_DISABLE_MODAL_PRIMARY,
		        primary_event: function() {
		        	CostcoPayFob.manageCostcoPayFob(fobData, 'suspend');
		          COSTCO.dialog.clearStack();
		          COSTCO.dialog.close();
		        },
		        secondary: messages.JS_DIALOG_CANCEL
		      });
		},
		/**
		 * Helper function used to activate a given fob
		 */
		activateFob: function(element) {
			let fobNumber = $(element).data("fob-num");
			let fobData = CostcoPayFob.getFobData(fobNumber); 
			CostcoPayFob.manageCostcoPayFob(fobData, 'activate');
		},
		/**
		 * Function used to remove/deactivate a fob
		 * It will prompt the user to confirm that they
		 * want to complete the action as its not revertable
		 */
		removeFob: function(element) {
			let fobNumber = $(element).data("fob-num");
			let fobData = CostcoPayFob.getFobData(fobNumber); 
			COSTCO.dialog.showAndHideModal({
		        title: messages.COSTCO_PAY_FOB_REMOVE_MODAL_TITLE,
		        body: COSTCO.util.tmpl('tmpl_remove_fob_modal',fobData),
		        primary: messages.COSTCO_PAY_FOB_REMOVE_MODAL_PRIMARY,
		        primary_event: function() {
		        	CostcoPayFob.manageCostcoPayFob(fobData, 'deactivate');
		          COSTCO.dialog.clearStack();
		          COSTCO.dialog.close();
		        },
		        secondary: messages.JS_DIALOG_CANCEL
		      });
		},
		/**
		 * Open the modal for a user to be able to add, edit, or deactivate a costcoPayFob
		 * 
		 * On edit we expect to recieve the fobNumber that we want to edit which will be passed
		 * to a helper function to get the data. After which the function will use the data to 
		 * populate the template form with the necessary information
		 * 
		 * On edit mode we want to add a footer to allow the user to deactivate a fob, which have
		 * a confirmation dialog hence we are using the modal stacking method from the dialog
		 */
		openAddEditFobModal: function(fobNumber, action) {
			
			let modalBodyTmpl = undefined;
			
			if(action === 'edit') {
				let fobData = CostcoPayFob.getFobData(fobNumber);
				modalBodyTmpl = COSTCO.util.tmpl('tmpl_costco_pay_fob_edit_dialog_box',fobData)
			}
			else {
				let fobData  = {};
				if(typeof fobNumber !== "undefined" && fobNumber > 0) {
					fobData.fobNumber = fobNumber;
				}
				else {
					fobData.fobNumber = "";
				}
				fobData.fobName = CostcoPayFob.getDefaultFobName();
				modalBodyTmpl = COSTCO.util.tmpl('tmpl_costco_pay_add_dialog_box',fobData);
				modalBodyTmpl = $(modalBodyTmpl);
				modalBodyTmpl.find('[name=costcoPayUserId]').val(COSTCO.CostcoPayAccountInformation.getCostcoPayUserId());
				modalBodyTmpl.find('[name=fobStatus]').val('active');
			}
			
			let modalOptions = {
					title: (action ==='edit') ? messages.COSTCO_PAY_FOB_EDIT_MODAL_TITLE : messages.COSTCO_PAY_FOB_ADD_MODAL_TITLE ,
					body: modalBodyTmpl,
					primary: messages.COSTCO_PAY_FOB_MODAL_PRIMARY,
					primary_event: function() {
						if(CostcoPayFob.validateCostcoPayFobForm(CostcoPayFob.getForm())) {
							let formFobData = COSTCO.util.objectifyArray(CostcoPayFob.getForm().serializeArray())
							CostcoPayFob.manageCostcoPayFob(formFobData, action);
						}
			        },
					secondary: messages.COSTCO_PAY_FOB_MODAL_SECONDARY
				}
			COSTCO.dialog.modalStack(modalOptions);
			COSTCO.util.accesible_popover($('.co-info, .co-help'));
			if(COSTCO.util.isRunningOnMobileApp())
	  			  $('.fob-scan-btn').show();
	  		  else
	  			  $('.fob-scan-btn').hide();
		},
		/**
		 * Function used to populate the fob number input based on what is passed
		 * into the function.
		 * 
		 * This function will be called by the Android or iOS device to enter the
		 * scanned QR code with the fob number that was obtained from the QR code
		 */
		populateFobNumber: function(fobNumberVal) {
			let form = CostcoPayFob.getForm();
			form.find('[name=fobNumber]').val(fobNumberVal);
			form.find('[name=fobNumberVerify]').val(fobNumberVal);
		},
		/**
		 * Function used to invoke the mobile app QR scanner
		 * used to populate the fobNumber from the QR Code
		 */
		showMobileQRScanner: function() {
			console.log('Initializing QR Scanner');
			try {
		        if (typeof Android != 'undefined') {
		        	Android.showQRScanner()
		        } 
		        else if (typeof webkit != 'undefined') {
		        	let messageToPost = {'callback' : 'COSTCO.CostcoPayFob.populateFobNumber'};
		        	webkit.messageHandlers.showQRScanner.postMessage(messageToPost);
		        }
		      }
		      catch (e) {
		        console.warn(e);
		      }
		},
		/**
		 * Validation function to send the costco pay fob form
		 * Fob name and number is always required
		 * Fob email is optional unless the user check the notify
		 */
		validateCostcoPayFobForm: function(element) {
			//Need to get the proper id for the fobNumber input as we are using the same validate
			//function for both the modal and inline form
			let fobNumberInputId = '#'+$(element).find('[name="fobNumber"]').attr('id');
			$.validator.addMethod("checkSpecialchar", function( value, element ) {
				return this.optional(element) || !(/([^A-Za-z0-9\.\'\-\&\s])/).test(value); // CC name shouldn't have any html tag
				
			});
			$(element).validate({
				rules: {
					fobName: {required: true,
							  maxlength: 50,
							  checkSpecialchar: true},
					fobNumber: {required: true,
								digits: true,
								minlength: 10,
								maxlength: 10},
					fobNumberVerify: {equalTo: fobNumberInputId}
							  
				},
				messages: {
					fobName: {
						required: messages.ERR_COSTCO_PAY_REQUIRED_FOB_NAME,
						maxlength: messages.ERR_COSTCO_PAY_MAXLENGTH_FOB_NAME,
						checkSpecialchar: messages.ERR_COSTCO_PAY_INVALID_FOB_NAME
					},
					fobNumber: {
						required: messages.ERR_COSTCO_PAY_REQUIRED_FOB_NUM,
						digits: messages.ERR_COSTCO_PAY_INVALID_FOB_NUM,
						minlength: messages.ERR_COSTCO_PAY_INVALID_FOB_NUM,
						maxlength:  messages.ERR_COSTCO_PAY_INVALID_FOB_NUM
					},
					fobNumberVerify:{
						equalTo: messages.ERR_COSTCO_PAY_MISMATCH_FOB_NUM
					}
				},
				errorPlacement: function(error, element) {
					let errrorCont = undefined;
					let form = CostcoPayFob.getForm();
					if(element.attr("name") == "fobNumber") {
						errorCont = $(form).find('[name=fob_number_error]');
					}
					else if(element.attr("name") == "fobNumberVerify") {
						errorCont = $(form).find('[name=fob_number_verify_error]');
					}
					else {
						errorCont = $(form).find('[name=fob_name_error]');
					}
					errorCont.empty();
					error.appendTo(errorCont);
					errorCont.removeClass('hide');
				},
				highlight: function(element, errorClass, validClass) {
					$(element).addClass(errorClass).removeClass(validClass);
					if($(element).attr("name") == "fobNumber") {
						$('.fob-scan-btn').addClass(errorClass).removeClass(validClass);
					}
				},
				unhighlight: function(element, errorClass, validClass) {
					$(element).addClass(validClass).removeClass(errorClass);
					if($(element).attr("name") == "fobNumber") {
						$('.fob-scan-btn').addClass(validClass).removeClass(errorClass);
					}
				}
			});
			return $(element).valid();
			
		},
		/**
		 * Function used to perfom the ajax call to perfom any management action againts a 
		 * costcoPayFob. Upon completion we will re-initialize the fob list with the latest
		 * information
		 */
		manageCostcoPayFob: function(fobData, action){
			
			$('#fob-section').addClass('ajax-busy');
			
			COSTCO.util.ajax({
		        url: CostcoPayFob.url.MANAGE_FOB_ADD_UPDATE,
		        method: 'POST',
		        dataType: 'json',
		        data: {
		          action: action,
		          costcoPayUserId:fobData.costcoPayUserId,
		          costcoPayFobNum:fobData.fobNumber,
		          costcoPayFobName:fobData.fobName,
		          costcoPayFobStatus: fobData.fobStatus
		        },
		        done: function(data) {
		        	if(data.errorMessage) {
		        		//If there is error and its duplicate fob show error next to fob number
		        		let form = CostcoPayFob.getForm();
		        		if(data.errorMessageKey == 'ERR_COSTCO_PAY_DUPLICATE_FOB_ID') {
		        			let errorCont = $(form).find('[name=fob_number_error]');
		        			errorCont.empty();
		        			errorCont.html('<label for="fob_number_input" class="error">'+data.errorMessage+'</label>');
		        			
		        			let input = $(form).find('[name=fobNumber]');
		        			input.addClass('error');
		        			input.attr('aria-invalid',true);
		        		}
		        		else if(data.errorMessageKey == 'ERR_COSTCO_PAY_DUPLICATE_FOB_NAME') {
		        			let errorCont = $(form).find('[name=fob_name_error]');
		        			errorCont.empty();
		        			errorCont.html('<label for="fob_name_error" class="error">'+data.errorMessage+'</label>');
		        			
		        			let input = $(form).find('[name=fobName]');
		        			input.addClass('error');
		        			input.attr('aria-invalid',true);
		        		}
		        		else {
		        			let errorCont = $(form).find('.critical-notification');
		        			errorCont.text(data.errorMessage);
		        			errorCont.removeClass('hide');
		        		}
		        	}
		        	else {
		        		CostcoPayFob.getCostcoPayFobs();
		        		if(action!== undefined && action === 'add')
		        			CostcoPayFob.showConfirmationModal(fobData);
		        		else {
		        			COSTCO.dialog.clearStack();
							COSTCO.dialog.close();
		        		}
		        	}
		        },
		        always: function() {
		        	$('#fob-section').removeClass('ajax-busy');
		        }
		    });
		},
		/**
		 * Function to show the fob added sucessfully confirmation modal
		 * this function will be invoked when a fob has been added sucessfully
		 * the function require the fobData to be passed in so it can show then
		 */
		showConfirmationModal: function(fobData) {
			
			let modalOptions = {
					hideHeader:true ,
					body: COSTCO.util.tmpl('tmpl_fob_added_confirmation_modal',fobData),
					primary: messages.COSTCO_PAY_FOB_ADDED_CONFIRM_MODAL_PRIMARY,
					primary_event: function() {
						COSTCO.dialog.clearStack();
						COSTCO.dialog.close();
			        },
					secondary: messages.COSTCO_PAY_FOB_ADDED_CONFIRM_MODAL_SECONDARY,
					secondary_event: function (){
						CostcoPayFob.openAddEditFobModal(-1, 'add');
					}
				}
			COSTCO.dialog.modalStack(modalOptions);
			$('#add_fob_form input[name=fobName]').val('');
			$('#add_fob_form input[name=fobNumber]').val('');
			$('#add_fob_form input[name=fobNumberVerify]').val('');
		},
	}
	window.COSTCO.CostcoPayFob = CostcoPayFob;
	return CostcoPayFob;
});


// WEBPACK FOOTER //
// ./js/account/costcopay-fob.js